import React, { useState, useEffect } from "react";
import { message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { DynamicModal } from "@/shared/components/Modal/DynamicModal";
import styled from "styled-components";

const RationaleTextArea = styled.textarea`
	width: 100%;
	min-height: 120px;
	border-radius: 8px;
	border: 1px solid #d9d9d9;
	padding: 12px;
	font-size: 14px;
	resize: vertical;
`;

const RationaleCharCount = styled.div`
	margin-top: 8px;
	color: #666;
	font-size: 13px;
	text-align: right;
`;

interface RationaleModalProps {
	open: boolean;
	initialValue?: string;
	onCancel: () => void;
	onSave: (value: string) => Promise<void> | void;
	loading?: boolean;
	title?: React.ReactNode;
	description?: React.ReactNode;
}

export const RationaleModal: React.FC<RationaleModalProps> = ({
	open,
	initialValue = "",
	onCancel,
	onSave,
	loading = false,
	title = "Write Rationale",
	description = "Reason to choose this Creator",
}) => {
	const [value, setValue] = useState<string>(initialValue);

	useEffect(() => {
		setValue(initialValue || "");
	}, [initialValue, open]);

	const handleConfirm = async () => {
		try {
			await onSave(value);
		} catch (err: any) {
			message.error(err?.response?.data?.message || "Failed to save rationale");
			throw err;
		}
	};

	return (
		<DynamicModal
			open={open}
			onCancel={onCancel}
			title={title}
			description={description}
			icon={<EditOutlined style={{ fontSize: 36 }} />}
			confirmText="Submit"
			cancelText="Cancel"
			loading={loading}
			onConfirm={handleConfirm}
			width={520}
		>
			<div>
				<RationaleTextArea
					autoFocus
					value={value}
					onChange={(e) => {
						if (e.target.value.length <= 1000) setValue(e.target.value);
					}}
					rows={5}
					maxLength={1000}
				/>
				<RationaleCharCount>{value.length}/1000</RationaleCharCount>
			</div>
		</DynamicModal>
	);
};

export default RationaleModal;
